import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faTimes } from '@fortawesome/free-solid-svg-icons';
const BuyMeACoffeeButton = () => {
    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const handleDonate = () => {
        window.open('https://buymeacoffee.com/swimlab', '_blank');
        handleCloseModal();
    };
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", className: "btn-ghost profile-settings-trigger", "aria-label": "Buy me a coffee", title: "Buy me a coffee", style: { color: 'var(--primary-light)' }, onClick: handleOpenModal },
            React.createElement(FontAwesomeIcon, { icon: faHeart })),
        showModal && (React.createElement("div", { className: "modal-backdrop", onClick: handleCloseModal },
            React.createElement("div", { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "modal-header" },
                    React.createElement("h3", null,
                        React.createElement(FontAwesomeIcon, { icon: faHeart, style: { marginRight: '8px', color: 'var(--primary-light)' } }),
                        "Support Swim Lab"),
                    React.createElement("button", { type: "button", className: "modal-close", onClick: handleCloseModal, "aria-label": "Close" },
                        React.createElement(FontAwesomeIcon, { icon: faTimes }))),
                React.createElement("div", { className: "modal-body" },
                    React.createElement("p", { style: { margin: '0 0 12px 0' } }, "If you find Swim Lab helpful, consider buying me a coffee to support ongoing development and improvements!"),
                    React.createElement("p", { style: { margin: 0, fontSize: '12px', color: 'var(--text-secondary)' } }, "Your support helps keep this platform free and ad-free for everyone.")),
                React.createElement("div", { className: "modal-actions" },
                    React.createElement("button", { type: "button", className: "btn", onClick: handleCloseModal }, "Maybe Later"),
                    React.createElement("button", { type: "button", className: "btn", onClick: handleDonate, style: { backgroundColor: 'var(--danger, #ff6b6b)', color: '#fff', border: 'none' } },
                        React.createElement(FontAwesomeIcon, { icon: faHeart, style: { marginRight: '8px' } }),
                        "Buy Me A Coffee")))))));
};
export default BuyMeACoffeeButton;
